import {Component, OnInit} from '@angular/core';

import {NetworkHelperService} from '../../_services/network-helper.service';
import {FORMS, API, CODFUNC, PAGE, GENERALES} from '../../_config/strings';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import * as alertfy from 'alertifyjs';

import Swal from 'sweetalert2';
import {Usuario} from '../../_model/Usuario';
import {Subject} from 'rxjs/Subject';
import { count } from 'rxjs/operators';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.scss']
})
export class NotificacionesComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  FORMS: any;
  API: any;
  CODFUNC: any;
  PAGE: any;
  GENERALES: any;

  public usuario: Usuario = new Usuario();
  notificacionesArray = [];
  copia = [];
  noti = [];
  estado = true;

  noti2 = [];

  audio;

  notificaciones = [];
  elementosMenu;

  // tiempo variables

  constructor(
    
      private network: NetworkHelperService,
      private router: Router,
      private route: ActivatedRoute,
  ) {
    this.FORMS = FORMS;
    this.API = API;
    this.CODFUNC = CODFUNC;
    this.GENERALES = GENERALES;
    this.PAGE = PAGE;
    this.usuario = JSON.parse(localStorage.getItem('usuario'));
    //this.router.routeReuseStrategy.shouldReuseRoute = function() {return false; };
    if(!this.usuario)
    {
        this.getUser();
    }
  }

  ngOnInit() {
   this.getNotifica();
  }

  getNotifica() {
    this.estado = true;
    this.getNotificaciones();
    this.estado = false;

    // console.log(this.notificacionesArray);
  }

  setEstatus(id)
  {
    this.network.callSecureService(
      this.API.user.notificaciones + '/' + id,
      'GET',
      null)
      .subscribe((response: any) => {
        console.log('cambio ok');
    }, err => {
      console.log(err);
      Swal('Error', 'algo paso al enviar el cambio de estatus', 'error');
    });
  }

  getNotificaciones() {
    this.network.callSecureService(
        this.API.user.notificaciones+'/all',
        'GET',
        null)
        .subscribe((response: any) => {
              console.log(response);
              this.notificacionesArray = [];
              for (const notificaciones of response.Mensaje) {
              // separemos la fecha para mostrarl mejor y hace calculos
                const arrayFecha = notificaciones.fecha.split('+');
                const fecha = arrayFecha[0];
                // console.log(moment().format('HH:mm:ss'));
                const date = moment(fecha).fromNow(true);
                this.notificacionesArray.push({
                  id: notificaciones.id,
                  mensaje: notificaciones.mensaje,
                  sucursalNombre: notificaciones.sucNombre,
                  url: notificaciones.url,
                  tiempo: date,
                  user: notificaciones.usuarioNombre,
                  iconVisto: notificaciones.estatus.estatus

                 // estatus: notificaciones.estatus
                });
                

              }
              this.notificacionesArray.reverse();
              this.noti = this.notificacionesArray;

              this.dtTrigger.next();

            }, err => {
              console.log(err);
              Swal('Error', this.GENERALES.algoOcurrio, 'error');
            }
        );

  }

  getUser() {

    if (localStorage.getItem('usuario')) {
        this.usuario = JSON.parse( localStorage.getItem('usuario') );
    }
}
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/notificaciones/notificaciones.component.ts